module.exports = __webpack_public_path__ + "static/media/SofiaProSemiBold.4cd3420e.woff";